// Dependencies
import React, { Fragment, FunctionComponent } from 'react'

// Components
import { ConditionallyRender } from 'component-library/conditionally-render'

// Styles
import { ButtonWrapper, Label, Loader } from './button.styles'

// Types
import { ButtonProps } from './button.types'

export const Button: FunctionComponent<ButtonProps> = ({
  label,
  iconElement,
  isLoading,
  isDisabled,
  variant = 'primary',
  size = 'large',
  isFullyAdaptative,
  ...buttonDefaultProps
}) => {
  return (
    <ButtonWrapper
      className="sisu-button"
      variant={variant}
      size={size}
      isFullyAdaptative={!!isFullyAdaptative}
      disabled={isDisabled || isLoading}
      {...buttonDefaultProps}
    >
      <ConditionallyRender
        shouldRender={!isLoading}
        content={
          <Fragment>
            <ConditionallyRender
              shouldRender={!!label}
              content={<Label>{label}</Label>}
            />

            {iconElement}
          </Fragment>
        }
      />

      <ConditionallyRender
        shouldRender={!!isLoading}
        content={
          <Loader>
            <div>
              <div />
              <div />
              <div />
              <div />
            </div>
          </Loader>
        }
      />
    </ButtonWrapper>
  )
}
